export default __webpack_public_path__ + "static/media/agency.ac814fac.svg";